import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCf55G_9BWpFwP4h6fH0b8KGnjnJ0HoHN8",
  authDomain: "head-s-up.firebaseapp.com",
  projectId: "head-s-up",
  storageBucket: "head-s-up.firebasestorage.app",
  messagingSenderId: "10237264023",
  appId: "1:10237264023:web:1e115bc49bc4d35f20a9d2",
  measurementId: "G-T1SMBY90XL"
};

// Inicjalizacja Firebase
const app = initializeApp(firebaseConfig);

// Eksportujemy usługi, by użyć ich w innych plikach gry
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Funkcje pomocnicze do logowania i wylogowywania
export const loginWithGoogle = () => signInWithPopup(auth, googleProvider);
export const logoutUser = () => signOut(auth);